<div class="close_icon">
  <mat-icon matSuffix (click)="close()">close</mat-icon>
</div>

<div class="main-container">
  <!-- STEP 1: Having trouble choosing a plan? -->
  <ng-container *ngIf="currentStep === 1">
    <span class="main-title">{{
      "exitIntent.havingTroubleChoosing" | translate
    }}</span>
    <span class="title">{{
      "exitIntent.selectTheBiggestChallenge" | translate
    }}</span>

    <div class="main-box">
      <div *ngIf="reasonList?.length > 0">
        <div *ngFor="let reason of reasonList" style="margin-bottom: 12px">
          <label class="box">
            <input
              type="radio"
              [name]="reason.name"
              [value]="reason.id"
              [(ngModel)]="selectedReasonId"
            />
            <span>{{ "exitIntent." + reason.value | translate }}</span>
          </label>
        </div>
      </div>
    </div>

    <div class="lower-box">
      <button
        type="button"
        class="submit"
        mat-icon-button
        matSuffix
        [disabled]="!selectedReasonId"
        (click)="submit()"
      >
        {{ "exitIntent.submit" | translate }}
      </button>
      <button
        type="button"
        class="continue"
        mat-icon-button
        matSuffix
        (click)="continue()"
      >
        {{ "exitIntent.continue" | translate }}
      </button>
    </div>
  </ng-container>

  <!-- STEP 2: Tell us more -->
  <ng-container *ngIf="currentStep === 2">
    <span class="main-title">{{ "exitIntent.tellUsMore" | translate }}</span>
    <span class="title">{{
      "exitIntent.additionalDetailsHelp" | translate
    }}</span>

    <div class="main-box textarea-box">
      <textarea
        [placeholder]="'exitIntent.shareFeedback' | translate"
        [(ngModel)]="customReason"
        class="inputReason"
      ></textarea>
    </div>

    <div class="lower-box">
      <button
        type="button"
        class="submit"
        mat-icon-button
        matSuffix
        [disabled]="isSubmitting"
        (click)="submitCustomReason()"
      >
        {{ isSubmitting ? "submittin..." : ("exitIntent.submit" | translate) }}
      </button>
      <button
        type="button"
        class="continue"
        mat-icon-button
        matSuffix
        [disabled]="isSubmitting"
        (click)="continue()"
      >
        {{ "exitIntent.skip" | translate }}
      </button>
    </div>
  </ng-container>

  <!-- STEP 3: Thank you -->
  <ng-container *ngIf="currentStep === 3">
    <div class="thank-you-container">
      <span class="main-title">{{ "exitIntent.thankYouFeedback" | translate }}</span>
      <span class="title">{{
        "exitIntent.appreciateYourTime" | translate
      }}</span>      
    </div>
     <div class="thank-you-button-box">
      <button
        type="button"
        class="submit"
        mat-icon-button
        matSuffix
        (click)="continue()"
      >
        {{ "exitIntent.continue" | translate }}
      </button>
     </div>
  </ng-container>
</div>
